import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Announcement, AnnouncementFormValue } from '../types/announcement.types';
import { DetailResponse } from '@synegen/utility';

@Injectable({ providedIn: 'root' })
export class AnnouncementApiService {
  private http = inject(HttpClient);
  private base = 'announcement';

  getAnnouncement(id: number): Observable<DetailResponse<Announcement>> {
    return this.http.get<DetailResponse<Announcement>>(`${this.base}/${id}`, {
      params: {}
    });
  }

  createAnnouncement(value: AnnouncementFormValue): Observable<DetailResponse<Announcement>> {
    return this.http.post<DetailResponse<Announcement>>(this.base, value);
  }

  updateAnnouncement(id: number, value: AnnouncementFormValue): Observable<DetailResponse<Announcement>> {
    return this.http.put<DetailResponse<Announcement>>(`${this.base}/${id}`, value);
  }
}
